<template>
  <div class="contest-entry-complete">
    <h2>{{ $t("contestEntryComplete.title") }}</h2>
    <p>{{ $t("contestEntryComplete.thankYou") }}</p>
    <p>{{ $t("contestEntryComplete.scheduleNotice") }}</p>
    <br />
    <table border="1">
      <tr v-for="schedule in contest.schedule" :key="schedule.name">
        <th>{{ schedule.name }}</th>
        <td>{{ schedule.value }}</td>
      </tr>
    </table>
    <br />
    <p>{{ $t("contestEntryComplete.emailNotice") }}</p>
    <br />
    <p>{{ $t("contestEntryComplete.closing1") }}</p>
    <p>{{ $t("contestEntryComplete.closing2") }}</p>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { NolaContest } from "@/lib/models/nolaContest";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    contest: Object as PropType<NolaContest>,
  },
});

interface Props {
  contest: NolaContest;
}

interface Data {}

interface Computed {}

interface Methods {}
</script>

<style lang="scss" scoped>
.contest-entry-complete {
  padding: 0 20%;
  color: var(--color-text-normal);
}

p {
  font-size: 1.1em;
  color: var(--color-text-normal);
}

table {
  border-collapse: collapse;
  border: 1px solid var(--color-border);
  font-size: 1.1em;

  tr {
    th {
      padding: 10px 15px;
      background-color: var(--color-surface-muted);
      color: var(--color-text-normal);
    }

    td {
      padding: 10px 15px;
      color: var(--color-text-normal);
    }
  }
}
</style>
